"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeSliderBounds = computeSliderBounds;
const offerQuote_1 = require("../offerQuote");
const offerDetails_1 = require("./offerDetails");
const sliderBounds_1 = require("./sliderBounds");
function computeSliderBounds(offers, selectedDebtSwapTradelines, roundRefiAdditionalFloor = false) {
    let minCashAndPayoffCents = Infinity;
    let maxCashAndPayoffCents = -Infinity;
    for (const offer of offers) {
        const minBound = (0, sliderBounds_1.minCashAndPayoffForLineSizeCents)(offer.offer, offer.minLineSizeCents);
        const maxBound = (0, offerQuote_1.cashAndPayoffForLineSizeCents)(offer.offer, offer.maxLineSizeCents);
        if (minBound < minCashAndPayoffCents) {
            minCashAndPayoffCents = minBound;
        }
        if (maxBound > maxCashAndPayoffCents) {
            maxCashAndPayoffCents = maxBound;
        }
    }
    if (minCashAndPayoffCents === Infinity || maxCashAndPayoffCents === -Infinity) {
        return { error: `bounds never set (min=${minCashAndPayoffCents}, max=${maxCashAndPayoffCents})` };
    }
    minCashAndPayoffCents = Math.max(0, minCashAndPayoffCents);
    // The shared slider axis includes the largest refinance payoff among its offers.
    const refiPayoffCents = Math.max(0, ...offers.map((offer) => offer.refiPayoffCents));
    const selectedDebtSwapPayoffCents = selectedDebtSwapTradelines.reduce((sum, t) => sum + t.balanceCents, 0);
    const payoffCents = refiPayoffCents + selectedDebtSwapPayoffCents;
    // The floor can exceed the ceiling on the net axis even when the gross requirement fits, e.g.
    // when recording tax eats the remaining headroom. That leaves no draggable position.
    if (minCashAndPayoffCents > maxCashAndPayoffCents) {
        return { error: `minCashAndPayoffCents=${minCashAndPayoffCents} exceeds maxCashAndPayoffCents=${maxCashAndPayoffCents}` };
    }
    // Round the net cash floor (additional above the committed payoff) up to the nearest $1,000,
    // capped at the ceiling so a refi near the max line still renders.
    if (roundRefiAdditionalFloor) {
        minCashAndPayoffCents = Math.min((0, offerDetails_1.roundCashAdditionalUpToNearestThousand)(minCashAndPayoffCents, payoffCents), maxCashAndPayoffCents);
    }
    return {
        minCashAndPayoffCents,
        maxCashAndPayoffCents,
        payoffCents,
        refiPayoffCents,
        debtSwapPayoffCents: selectedDebtSwapPayoffCents,
    };
}
